import { render, staticRenderFns } from "./CapitecBankForm.vue?vue&type=template&id=05574f60"
import script from "./CapitecBankForm.vue?vue&type=script&lang=js"
export * from "./CapitecBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports